import toast from 'react-hot-toast';

const showSomethingWentWrongToast = () => {
  toast.error('Something went wrong, please try again');
};

export default showSomethingWentWrongToast;
